<script setup lang="ts">
import { ArrowUpRight } from '@lucide/vue'
import type { ExecutionResource } from '@zerohuman/shared'

defineProps<{ resources: ExecutionResource[] }>()
</script>

<template>
	<ul v-if="resources.length" data-testid="execution-resources" class="flex flex-wrap gap-2">
		<li v-for="resource in resources" :key="resource.url">
			<a
				:href="resource.url"
				target="_blank"
				rel="noreferrer"
				class="border-border bg-background hover:bg-muted inline-flex items-center gap-1 border px-2.5 py-1 text-xs"
			>
				{{ resource.name }}
				<ArrowUpRight class="size-3 shrink-0" aria-hidden="true" />
			</a>
		</li>
	</ul>
</template>
